import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const getById = params => {
  return ApiService.query(`store/${params.id}`);
};
export const follow = params => {
  return ApiService.post(`store/${params.id}/follow`);
};
export const unFollow = params => {
  return ApiService.post(`store/${params.id}/unfollow`);
};
export const me = params => {
  // 메인 페이지에서 호출시 loading false로 처리 - 20230206 jsy
  return ApiService.query(`store/me?${stringify(params)}`, {
    isLoading: params.isLoading !== undefined ? params.isLoading : true,
  });
};
export const recommend = params => {
  return ApiService.query(`store/recommend?${stringify(params)}`);
};
export const getStoreByUserId = params => {
  return ApiService.query(`store/find/${params.userId}`);
};
export const setStoreMessage = params => {
  return ApiService.put(`store/message`, params);
};
export const setStoreMessageDel = params => {
  return ApiService.post(`store/message/${params.id}`);
};
export const search = params => {
  return ApiService.query(`store/find?${stringify(params)}`, {
    isLoading: params.isLoading !== undefined ? params.isLoading : true,
  });
};
export const getStorePriorConsent = params => {
  return ApiService.query(`store/certs/${params.id}`);
};
export const setStorePriorConsent = params => {
  return ApiService.post(`store/certs`, params);
};
export const getVouchersCnt = params => {
  return ApiService.query(`store/vouchers/cnt`, params);
};
export const setStoreVouchersUse = params => {
  return ApiService.post(`store/vouchers/use?${stringify(params)}`);
};
export const getStoreVouchers = params => {
  return ApiService.query(`store/vouchers?${stringify(params)}`);
};
export const setOnlineApply = params => {
  return ApiService.post(`store/online`, params);
};
export const getFollowers = params => {
  return ApiService.query(`store/followers?${stringify(params)}`);
};
